import axios from 'axios';
import i18next from 'i18next';
const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
console.log('base url', apiUrl);
const apiClient = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': '69420',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['lang'] = i18next.language || 'en';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// apiClient.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response && error.response.status === 401) {
//       try {
//         const { data } = await apiClient.post("/refresh-token");
//         localStorage.setItem("authToken", data.token);
//         error.config.headers["Authorization"] = `Bearer ${data.token}`;
//         return apiClient.request(error.config);
//       } catch (refreshError) {
//         console.error("Token refresh failed, logging out...");
//         window.location.href = "/login";
//       }
//     }
//     return Promise.reject(error);
//   }
// );

apiClient.interceptors.response.use(
  // (response) => response,
  (response) => {
    // For successful responses, translate the message if it exists
    if (response.data && response.data.message) {
      response.data.message = i18next.t(response.data.message, {
        ns: 'response',
      }); // Translates success message
    }
    return response;
  },
  (error) => {
    // Handle any global error response
    console.log('interceptors', error);
    if (
      error.response &&
      error.response.status === 401 &&
      error.response?.data?.message === 'Unauthenticated.'
    ) {
      // Handle unauthorized error (e.g., logout or redirect)
      console.error('Unauthorized access, logging out...');
      const token = localStorage.getItem('authToken');
      if (token) {
        localStorage.removeItem('authToken');
      }
      // Example: You might want to redirect to login page
      window.location.href = 'login';
    }

    const { response } = error;
    if (response) {
      const { status, data } = response;
      const translatedMessage = i18next.t(data?.message || 'UNEXPECTED_ERROR', {
        ns: 'response',
      });

      return Promise.reject({
        status,
        // message: data?.message || "An unexpected error occurred",
        message: translatedMessage, // Translated message
        data,
      });
    }
    // return Promise.reject({ message: "Network error. Please try again." });
    return Promise.reject({
      message: i18next.t('NETWORK_ERROR', { ns: 'response' }),
    });
  }
);

export default apiClient;
